import { Typography } from '@mui/material'
import { memo } from 'react'
import tw from 'twin.macro'
import LoggedOutImage from 'src/assets/images/logged-out.png'
import { colors } from 'src/theme'

const EmptySubcontractorsComponent = () => {
  return (
    <div css={tw`flex flex-1 h-full justify-center items-center flex-col`}>
      <div css={tw`flex flex-col bg-white px-4 py-6 rounded-2xl w-[360px]`}>
        <img
          width={210}
          height={164}
          src={LoggedOutImage}
          alt="Empty state illustration"
          css={tw`mx-auto`}
        />
        <Typography css={tw`my-2 text-center m-auto`} variant="h4" fontWeight={600}>
          You haven't signed any partnerships yet.
        </Typography>
        <Typography
          css={tw`text-center m-auto w-[290px]`}
          color={colors.SHADES_GREY_400}
          variant="body2"
        >
          To start linking contractors with customers, you'll need to sign a partnership agreement
          first.
          <br />
          <br />
          Reach out to your customer and ask them to send you a master contractor invite — or
          contact our support team if you need help getting started.
        </Typography>
      </div>
    </div>
  )
}

export const EmptySubcontractors = memo(EmptySubcontractorsComponent)
